// extracted by mini-css-extract-plugin
export default {"createFaivePage":"createFaivePage___yUpM0","pageTitle":"pageTitle____fIEu"};